import React, { ComponentProps, FC } from 'react'

type Props = ComponentProps<'svg'>

export const RoovLogo: FC<Props> = props => {
  return (
    <svg viewBox="0 0 36 37" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M35.1891 35.4813C35.4001 36.0567 35.1076 36.3492 34.5322 36.1382L0.895876 23.6043C0.605851 23.4862 0.362296 23.2767 0.202197 23.0075C0.0420983 22.7384 -0.0257988 22.4244 0.00881675 22.1131L2.13776 8.72092C2.28614 8.04233 2.69397 7.44865 3.27415 7.06668L15.0361 0.277082C15.3434 0.12219 15.6785 0.0301144 16.0218 0.00623891C16.3651 -0.0176366 16.7098 0.0271665 17.0356 0.138029L29.2578 5.12474C29.5531 5.26359 29.8051 5.4802 29.9867 5.75134C30.1683 6.02249 30.2727 6.33795 30.2887 6.66391V21.0486C30.312 21.783 30.4428 22.51 30.6771 23.2064L35.1891 35.4813ZM5.50379 18.9101C5.46812 19.2197 5.53392 19.5324 5.6913 19.8013C5.84867 20.0703 6.08912 20.2808 6.37646 20.4013L26.9083 28.1691C27.2343 28.2938 27.3878 28.1259 27.2823 27.7999L25.7479 24.079C25.5151 23.3824 25.3859 22.6555 25.3643 21.9213V9.72306C25.351 9.46784 25.2686 9.22104 25.1259 9.00904C24.9831 8.79705 24.7855 8.62785 24.554 8.51954L17.2705 5.5419C16.9877 5.44585 16.6886 5.40699 16.3906 5.42757C16.0926 5.44815 15.8017 5.52776 15.5347 5.66177L7.74781 10.1594C7.17516 10.5322 6.77347 11.1167 6.63059 11.7849L5.50379 18.9101Z"
        fill="url(#paint0_linear_218:723)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_218:723"
          x1="4.34821"
          y1="30.1734"
          x2="34.1438"
          y2="12.9692"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#D9D200" />
          <stop offset="0.2" stopColor="#A7C79C" />
          <stop offset="0.7" stopColor="#00989A" />
          <stop offset="1" stopColor="#181D62" />
        </linearGradient>
      </defs>
    </svg>
  )
}
